import './style.scss'
import { useContext, useState } from "react"
import { AppCenterPopup } from "src/component/CenterPopup"
import VisibilityContext from 'src/provider/state-manager/visibilityProvider'
import { FlexRow, Button, CustomContainer, ScreenTitle, FormGroup, Form, FormGroupWithIcon } from "src/style"
import { FiChevronDown } from 'react-icons/fi'
import { CenterPopupHeader } from 'src/component'


export const ChangeAccountOfficer: React.FC<any> = ({close}) => {
    const {notifier} = useContext(VisibilityContext)
    const [input, setInput] = useState({accountOfficer: '', reason: ''})

    const handleInput = (e: React.ChangeEvent<HTMLInputElement|HTMLTextAreaElement|HTMLSelectElement>) => setInput({...input, [e.target.name]: e.target.value})

    function handleSubmit (e: React.FormEvent<HTMLButtonElement | HTMLFormElement>) {
        e.preventDefault()

        notifier.show('Change Request is Under Review', null, 'success')
        close()
    }
    
    return (
        <AppCenterPopup height='49.5' zIndex='8' close={close}>
            <CenterPopupHeader close={close} />
            <CustomContainer height="38.5" className='popup-content-container'>
                <CustomContainer topMargin="2">
                    <ScreenTitle textSize="2.2" fontWeight="700" align="center">Request Change</ScreenTitle>
                    <Form onSubmit={handleSubmit} topMargin='2'>
                        <FormGroupWithIcon>
                            <label>New Account Officer</label>
                            <div className="input-with-icon">
                                <select 
                                    name='accountOfficer'
                                    value={input.accountOfficer}
                                    style={{color: input.accountOfficer ? '#000000' : '#667085'}}
                                    onChange={handleInput}
                                    //required
                                >
                                    <option value="">Select New Accoun Officert</option>
                                </select>
                                <FiChevronDown className="input-with-icon-tag" />
                            </div>
                        </FormGroupWithIcon>
                        <FormGroup height='12.8' topMargin='2'>
                            <label>Reason from Change</label>
                            <textarea 
                                placeholder='Enter Reasons...' 
                                name='reason'
                                value={input.reason}
                                onChange={handleInput}
                            />
                        </FormGroup>
                        <Button 
                            width='100' sizeUnit="%" height='4.4' 
                            borderColor='#0D968F' hoverBgColor='#fff' 
                            hoverColor='#0D968F'
                            onClick={handleSubmit}
                        >
                            Proceed
                        </Button>
                    </Form>
                </CustomContainer>
            </CustomContainer>
        </AppCenterPopup>
    )
}
